import {
  AfterViewInit,
  DestroyRef,
  Directive,
  ElementRef,
  HostListener,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[currency]',
  standalone: true,
})
export class InputCurrencyDirective implements AfterViewInit {
  private readonly el = inject(ElementRef);

  private readonly ngControl = inject(NgControl);
  private readonly destroyRef = inject(DestroyRef);
  private _previousValue: string = '';
  private readonly _htmlInputElement: HTMLInputElement | null = null;
  private isFocused = false;
  private readonly regEx = new RegExp(
    /(^-?$)|(^[,|.]\d{0,2}$)|(^-?\d{1}[,|.]?\d{0,2}$)|^(-?[1-9][0-9]+[,|.]?\d{0,2})$|^(-?)(?:0)(\d+[,|.]?\d{0,2})$/,
    'g'
  );

  constructor() {
    const el = this.el;

    this._htmlInputElement = el.nativeElement;
  }

  ngAfterViewInit(): void {
    this.ngControl.valueChanges
      ?.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value: string) => {
        if (this._previousValue === '') {
          this._previousValue = this.getMatchedValue(this.ngControl.value);
        }
        if (this.isFocused) {
          const currentPosition = this._htmlInputElement?.selectionStart ?? 0;
          if (this.regEx.test(value)) {
            let initialValue = this.getMatchedValue(value);
            if (value !== initialValue) {
              this.ngControl.control?.setValue(initialValue, {
                emitEvent: false,
              });
            }
            if (this._previousValue !== initialValue) {
              this._previousValue = this.ngControl.value ?? '';
            }
            return;
          }
          this.ngControl.control?.setValue(this._previousValue, {
            emitEvent: false,
          });
          this._htmlInputElement?.setSelectionRange(
            currentPosition > 0 ? currentPosition - 1 : 0,
            currentPosition > 0 ? currentPosition - 1 : 0
          );
        }
      });
  }

  private getMatchedValue(value: string): string {
    let newValue =
      value?.replace(this.regEx, '$1$2$3$4$5$6').replace('.', ',') ?? '';
    return newValue;
  }

  @HostListener('focus') onFocus() {
    this.isFocused = true;
  }
  @HostListener('blur') onBlur() {
    this.isFocused = false;
  }
}
